<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <!-- <div class="col-xs-12 mainContent" :class="$route.meta.style">
          <router-view></router-view>
        </div> -->
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainContainer'
};
</script>
